module.exports = __webpack_public_path__ + "media/images/prediction/special/cycle/img_thumb-fe2778e1e115b40a8904469a98633c8d.jpg";